import { render, staticRenderFns } from "./ExternalNews.vue?vue&type=template&id=36850b10&scoped=true&"
import script from "./ExternalNews.vue?vue&type=script&lang=js&"
export * from "./ExternalNews.vue?vue&type=script&lang=js&"
import style0 from "./ExternalNews.vue?vue&type=style&index=0&id=36850b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36850b10",
  null
  
)

export default component.exports